import { ApplicationState } from "@redux/reducers";

export class AuthSelectors {
    public static isLoggedIn(state: ApplicationState): boolean {
        return !!state.auth.authToken;
    }
}
